/* eslint-disable react/no-unknown-property */
/* eslint-disable prefer-const */
import Button from 'components/UI_kit_3/Button/Button';
import dayjs from 'dayjs';
import { FormikHelpers, useFormik } from 'formik';
import useAsyncFetch from 'hooks/async-fetch';
import React from 'react';
import { Form, Modal } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { authService } from 'services/api/auth';
import { ErrorObj } from 'services/api/axios';
import { object, string } from 'yup';

interface IResetPasswordRequestModalProps {
  initialEmail?: string
}

const ResetPasswordRequestModal: React.FC<IResetPasswordRequestModalProps> = ({ initialEmail }) => {
  const [t, i18n] = useTranslation();
  const [show, setShow] = React.useState(false);

  const [sendEmail, loading, isSend] = useAsyncFetch<[{ email: string },
    FormikHelpers<{ email: string }>], boolean>({
    asyncFunc: async ({ email }) => {
      await authService.resetPasswordSendEmail(email, i18n.language);
      return true;
    },
    errorHandler: ({ errMessage, error, params }) => {
      const blockedError = error.response?.data?.errors?.find((err: ErrorObj) => err.code === 601);
      if (blockedError) {
        let [blockedMessage, blockedDate] = blockedError?.message ? blockedError.message.split(': ') : [];
        blockedDate = dayjs(blockedDate).format('DD.MM.YYYY HH:mm');
        params[1].setFieldError('email', `${blockedMessage}: ${blockedDate}`);
        return;
      }
      params[1].setFieldError('email', errMessage);
    },
    initialState: false,
  });

  const form = useFormik<{ email: string }>({
    initialValues: {
      email: initialEmail || '',
    },
    onSubmit: sendEmail,
    validationSchema: object().shape({
      email: string().email(t('form.error.wrong_value')).required(t('form.error.required')),
    }),
    enableReinitialize: true,
  });
  return (
    <>
      <Button variant="link" onClick={() => setShow(true)} qa-element="forgot-password">{t('auth.forgot_password')}</Button>
      <Modal show={show} centered onHide={() => setShow(false)} onExited={() => form.resetForm()}>
        <Modal.Header closeButton>
          <Modal.Title>{t('auth.password_reset')}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {
            isSend && (
              <p>{t('auth.email_has_been_sent')}</p>
            )
          }
          {
            !isSend && (
            <Form id="password-reset-form" noValidate onSubmit={form.handleSubmit}>
              <Form.Group controlId="email">
                <Form.Label className="required">Email</Form.Label>
                <Form.Control
                  name="email"
                  value={form.values.email}
                  onChange={form.handleChange}
                  isInvalid={!!form.errors.email && form.touched.email}
                  qa-element="email"
                />
                <Form.Control.Feedback type="invalid" qa-element="email-error">{form.errors.email}</Form.Control.Feedback>
                <Form.Text>{t('auth.reset_email_will_be_sent')}</Form.Text>
              </Form.Group>
            </Form>
            )
          }
        </Modal.Body>
        <Modal.Footer>
          {
            !isSend && (
              <Button disabled={loading} type="submit" form="password-reset-form" qa-element="send">{t('common.send')}</Button>
            )
          }
          {
            isSend && (
              <Button onClick={() => setShow(false)} qa-element="ok">{t('common.ok')}</Button>
            )
          }
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ResetPasswordRequestModal;
